// POS/services/userManagement.js (UserService.js)

import { jwtDecode } from 'jwt-decode';
import ApiService from './apiService';

class UserService {
  getUserRole(token) {
    if (!token) return null;
    try {
      const decoded = jwtDecode(token, { complete: true });
      const roleClaim = decoded?.roles; // adjust to decoded?.payload?.roles if needed
      return roleClaim || null;
    } catch (error) {
      console.error('Error decoding token (role):', error);
      return null;
    }
  }

  async getUserId(token) {
    if (!token) return null;

    try {
      const decoded = jwtDecode(token, { complete: true });
      const email = decoded?.email; // adjust to decoded?.payload?.email if needed
      if (!email) {
        console.error('Email not found in token');
        return null;
      }

      const apiService = new ApiService();
      const params = `?userEmail=${email}`;
      const response = await apiService.getApiParamater('GET_LOGGEDIN_USER', params);

      // Assuming API returns: { result: 12 }
      return response?.data?.result || null;
    } catch (error) {
      console.error('Error fetching user ID:', error);
      return null;
    }
  }

  getUserName(token) {
    if (!token) return null;
    try {
      const decoded = jwtDecode(token, { complete: true });
      const userName = decoded?.userName;
      return userName || null;
    } catch (error) {
      console.error('Error decoding token (userName):', error);
      return null;
    }
  }

  getUserCounter(token) {
    if (!token) return null;
    try {
      const decoded = jwtDecode(token, { complete: true });
      const counter = decoded?.CounterNo;
      return counter || null;
    } catch (error) {
      console.error('Error decoding token (counter):', error);
      return null;
    }
  }

  getUserCrud(token) {
    if (!token) return null;
    try {
      const decoded = jwtDecode(token, { complete: true });
      const crudValues = decoded?.crud;
      return crudValues || null;
    } catch (error) {
      console.error('Error decoding token (crud):', error);
      return null;
    }
  }
}

export default new UserService();
